module.exports = __webpack_public_path__ + "img/sixpackcarrier76.55bb8d2e.jpg";